<script setup>
  import { ref } from 'vue';
  import { ElButton, ElDrawer, ElConfigProvider } from 'element-plus'
  import Drawer from './components/utility/drawer.vue';
  import { Edit } from '@element-plus/icons-vue'
  import { useProductStore } from './stores/fpe'
  import { storeToRefs } from 'pinia'
  import { watch } from 'vue';


  const store = useProductStore();
  const { openPanel, strings, product } = storeToRefs(store);

  const showTriggerButton = ref(true);

  if(fpe.editor_config?.show_trigger_button == false){
    showTriggerButton.value = false;
  }

  // watch openPanel and trigger openDrawer function
  watch(openPanel, (val) => {
    if(val){
      openDrawer();
    }else{
      document.body.classList.remove('fpe-panel-open');
    }
  })

  const openDrawer = () => {

    
  }

</script>

<template>

  <ElConfigProvider namespace="el">
    <el-button v-show="showTriggerButton" type="primary" class="fpe-panel-trigger" :icon="Edit" @click="store.togglePanel" />
    <Drawer v-if="openPanel"  />
    <!-- <el-drawer 
      class="fpe-panel"
      append-to-body="true"
      modal-class="fpe-panel-wrapper" 
      v-model="openPanel" 
      :title="strings.update_product" 
      :with-header="true"
      @open="openDrawer"
      @closed="closeDrawer"
      z-index="9999"
      >
      <template #footer>
          <PanelFooter />
      </template>
      <Form />
    </el-drawer>  -->
  </ElConfigProvider>  
</template>

<style scoped>

</style>
